import axios from '@/libs/api.request'

export const getPlayList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/play'
  })
}

export const addPlay = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/play'
  })
}

export const editPlay = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/play'
  })
}

export const editPlaySort = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/play/sort'
  })
}

export const delPlay = (id) => {
  return axios.request({
    method: 'delete',
    url: '/play/' + id
  })
}

export const getPlayInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/play/' + id
  })
}

export const getPlayV2Info = (id) => {
  return axios.request({
    method: 'get',
    url: '/play/v2/' + id
  })
}

export const editPlayV2 = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/play/v2'
  })
}

export const changeStatus = (id) => {
  return axios.request({
    method: 'put',
    url: '/play/release/' + id
  })
}

export const changeDisplayStatus = (id) => {
  return axios.request({
    method: 'put',
    url: '/play/display/' + id
  })
}

export const uploadSeries = (data) => {
  return axios.request({
    method: 'post',
    url: '/play/upload',
    data
  })
}

export const mergeChunk = (data) => {
  return axios.request({
    method: 'post',
    url: '/play/upload/merge',
    data
  })
}

export const uploadSeriesChunk = (data, cancelTask) => {
  return axios.request({
    method: 'post',
    url: '/play/upload/chunk',
    data,
    ...cancelTask
  })
}

export const checkChunk = (params)=>{
  return axios.request({
    method: 'get',
    url: '/play/upload/chunks',
    params
  })
}

export const downloadVideo = (data)=>{
  return axios.request({
    method: 'post',
    url: '/play/video/download',
    data
  })
}

export const getBaiduAccounts = ()=>{
  return axios.request({
    method: 'get',
    url: '/play/video/accounts'
  })
}

export const getBaiduPath = (data)=>{
  return axios.request({
    method: 'post',
    url: '/play/video/path',
    data
  })
}

export const getPrimaryList = (params)=>{
  return axios.request({
    method: 'get',
    url: '/play/parent',
    params
  })
}

export const addPrimary = (data)=>{
  return axios.request({
    method: 'post',
    url: '/play/parent',
    data
  })
}

export const editPrimary = (data)=>{
  return axios.request({
    method: 'put',
    url: '/play/parent',
    data
  })
}

export const getPrimaryInfo = (id)=>{
  return axios.request({
    method: 'get',
    url: '/play/parent/'+id
  })
}

export const getPrimaryPlays = (params)=>{
  return axios.request({
    method: 'get',
    url: '/play/parent/plays',
    params
  })
}
export const getPrimaryLang = (id)=>{
  return axios.request({
    method: 'get',
    url: '/play/parent/langs/'+id,
  })
}

export const batchUpdateUnlock = (data)=>{
  return axios.request({
    method: 'post',
    data,
    url: '/play/update/unlocknum',
  })
}

export const getSeriesPreview = (data)=>{
  return axios.request({
    url: '/play/series/preview',
    method: 'post',
    data
  })
}

export const getPlayBatch = (params)=>{
  return axios.request({
    method: 'get',
    params,
    url: '/play/batch'
  })
}

export const batchOffline = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/play/batch/offline'
  })
}